import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

@Injectable()
export class BlogCategoryService {
  private apiPrefix = '/admin/blog-categories';

  constructor(
    private api: ApiService
  ) {
  }

  create(data: object) {
    return this.api.post(`${this.apiPrefix}`, data);
  }

  update(id: number, data: object) {
    return this.api.patch(`${this.apiPrefix}/${id}`, data);
  }

  delete(id: number) {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }

  getList(qs = '') {
    return this.api.get(`${this.apiPrefix}${qs}`);
  }
}
